import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private session: SessionService, private gaService: GoogleAnalyticsService) { }
  get isLeft() {
    return this.session.CurrentLang?.IsLeft;
  }
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    /* quick an dirty implementation of GA cookie requireents */
    let gaClientId = this.gaService.getGAClientId();
    let gaSessionId = this.gaService.getGASessionId();
    let deviceId = this.session.clientId;
    let appSource = sessionStorage.getItem('mobile') ? 'WebView' : 'Web'; 

    let headers = request.headers
      .set('Language', this.isLeft ? '2' : '1')
      .set('apikey', this.session.ApiKey || '58d4c8fd-f704-49ba-ae38-4dd20a5bea00')
      .set('GA-Client-Id', gaClientId)
      .set('GA-Session-Id', gaSessionId)
      .set('x-app-version', environment.version)
      .set('X-Device-Id', deviceId)
      .set('X-App-Source', appSource);

    request = request.clone({
      headers,
    });
    var tempToken = sessionStorage.getItem('tempToken');

    if (request.headers.get('Authorization') == 'ignore') {
      let headers = request.headers.delete('Authorization');
      request = request.clone({ headers, });
    } else if (tempToken && !request.headers.get('Authorization')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${tempToken}`,
        },
      });
    } else if (this.session.token && !request.headers.get('Authorization')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.session.token}`,
        },
      });
    }
    // console.log(request);
    return next.handle(request);
  }
}
